export default 'M14.06 5.44a1.5 1.5 0 0 0-2.12 0L8 9.38 4.06 5.44a1.5 1.5 0 1 0-2.12 2.12l5 5a1.5 1.5 0 0 0 2.12 0l5-5a1.5 1.5 0 0 0 0-2.12';